import CoordenadorService from '../../services/CoordenadorService'

const state = {
    coordenadores: [],
    coordenador: {},
    loading: false,
    page: 1,
    pages: 1,
    total: 0
}

const mutations = {
    SET_COORDENADOR(state, coordenador) {
        state.coordenador = coordenador;
    },
    SET_COORDENADORES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.coordenadores = payload.itens
        }else{
            state.coordenadores = [...state.coordenadores, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_COORDENADOR(state, loading) {
        state.loading = loading;
    },
}

const actions = {
    
    async fetchCoordenador({ commit }, id) {
        commit('SET_LOADING_COORDENADOR', true);
        try {
            const response = await CoordenadorService.getOne(id);
            commit('SET_COORDENADOR', response.data.item);
        } catch (error) {
            console.error('Erro ao buscar Coordenador:', error);
        } finally {
            commit('SET_LOADING_COORDENADOR', false);
        }
    },

    async fetchCoordenadores({ commit }, { keyword = '', pageNumber = 1, sortBy = 'mais recentes' }) {
        commit('SET_LOADING_COORDENADOR', true);
        try {
            const response = await CoordenadorService.get(keyword, pageNumber, sortBy);
            commit('SET_COORDENADORES', response.data);
        } catch (error) {
            console.error('Erro ao buscar Coordenadores:', error);
        } finally {
            commit('SET_LOADING_COORDENADOR', false);
        }
    },

    async createCoordenador({ commit }, data) {
        try {
            commit('SET_LOADING_COORDENADOR', true);
            const response = await CoordenadorService.create(data);
            commit('SET_ALERT', { heading: 'success', message: response.data.message });
            commit('SET_LOADING_COORDENADOR', false);
            return response.data.item;
        } catch (error) {
            commit('SET_LOADING_COORDENADOR', false);
            commit('SET_ALERT', { heading: 'error', message: error.response?.data?.message || 'Erro ao criar Coordenador' });
            throw error;
        }
    },

    async updateCoordenador({ commit }, data ) {
        try {
            const response = await CoordenadorService.update(data);
            commit('SET_ALERT', { heading: 'success', message: response.message });
            commit('SET_COORDENADOR', response.data.item);
        } catch (error) {
            commit('SET_ALERT', { heading: 'error', message: error.response?.data?.message || 'Erro ao atualizar Coordenador' });
            throw error;
        }
    },

    async deleteCoordenador({ commit }, id) {
        try {
            const response = await CoordenadorService.delete(id);
            commit('SET_ALERT', { heading: 'success', message: response.message });
        } catch (error) {
            commit('SET_ALERT', { heading: 'error', message: error.response?.data?.message || 'Erro ao excluir Coordenador' });
            throw error;
        }
    }
}

const getters = {
    getCoordenadores: state => state.coordenadores,
    getCoordenador: state => state.coordenador,
    getLoadingCoordenador: state => state.loading
}

export default {
    state,
    mutations,
    actions,
    getters
}